module.exports = __webpack_public_path__ + "img/Dossierscherm.0aff2324.png";